import React from 'react';
import { TrendingUpIcon, HomeIcon, ZapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const points = [{
  icon: HomeIcon,
  title: 'Homeowners are improving, not moving',
  description: 'High interest rates and energy costs mean people are investing in what they have instead of buying new.'
}, {
  icon: ZapIcon,
  title: 'Smart efficiency upgrades',
  description: "Windows, siding, and doors aren't luxury anymore — they're practical improvements that pay for themselves."
}, {
  icon: TrendingUpIcon,
  title: 'Built to scale nationwide',
  description: '10+ manufacturer partnerships, strong financing options, and logistics that ship anywhere in the country.'
}];
export function MarketTiming() {
  return <section className="py-20 bg-charcoal" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-92">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white mb-4" data-id="element-93">
            The market is wide open right now.
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-94">
            When NTY shows up with the right product, the right pricing, and the
            right people, it's a no-brainer for the customer.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-95">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 rounded-lg p-8 hover:border-maroon transition-colors" data-id="element-96">
              <div className="w-14 h-14 bg-maroon rounded-lg flex items-center justify-center mb-6" data-id="element-97">
                <point.icon className="w-7 h-7 text-white" data-id="element-98" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-99">
                {point.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-100">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}